import type { Middleware } from '@reduxjs/toolkit';
import { bugReporterActionLog } from './actionLog';

export function createBugReporterMiddleware(): Middleware {
  return () => (next) => (action) => {
    const typedAction = action as { type?: string };
    if (typedAction.type) {
      bugReporterActionLog.push({
        type: 'redux',
        detail: typedAction.type,
        timestamp: Date.now(),
      });
    }
    return next(action);
  };
}
